import api from './api';
import { confirmTwoFactor } from './twoFactor';

export const lookupCompanies = async (email) => {
  const response = await api.post('/login/companies', { email });
  return response.data.companies || [];
};

export const login = async (companyId, email, password) => {
  try {
    const payload = { email, password };
    if (companyId) payload.companyId = companyId;
    const response = await api.post('/login', payload);
    if (response.data.company_required) {
      return { companies: response.data.companies };
    }
    const data = response.data.two_factor_required
      ? await confirmTwoFactor(response.data.challenge_token, response.data.message)
      : response.data;
    return {
      user: data.user,
      companyId: companyId ?? data.user?.company_id ?? null,
    };
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Login failed');
  }
};

export const logout = async () => {
  await api.post('/logout');
};
